export default __webpack_public_path__ + "static/media/MychaPic.e35ca99c.jpeg";